__turbopack_context__.v({
  "content": "MainInfoSection-module-scss-module__YJ-qPW__content",
  "descriptionBlock": "MainInfoSection-module-scss-module__YJ-qPW__descriptionBlock",
  "descriptions": "MainInfoSection-module-scss-module__YJ-qPW__descriptions",
  "desktopImages": "MainInfoSection-module-scss-module__YJ-qPW__desktopImages",
  "firstImageItem": "MainInfoSection-module-scss-module__YJ-qPW__firstImageItem",
  "firstSection": "MainInfoSection-module-scss-module__YJ-qPW__firstSection",
  "imagesBlock": "MainInfoSection-module-scss-module__YJ-qPW__imagesBlock",
  "mobileImage": "MainInfoSection-module-scss-module__YJ-qPW__mobileImage",
  "mobileImages": "MainInfoSection-module-scss-module__YJ-qPW__mobileImages",
  "photo": "MainInfoSection-module-scss-module__YJ-qPW__photo",
  "secondImageItem": "MainInfoSection-module-scss-module__YJ-qPW__secondImageItem",
  "title": "MainInfoSection-module-scss-module__YJ-qPW__title",
});
